import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-details-icon',
  imports: [],
  templateUrl: './details-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './details-icon.component.scss',
})
export class DetailsIconComponent {}
